// /* factory */
import Scroll from "./factory";

const modul = angular
    .module("ScrollModule", [])

    .factory("Scroll", Scroll);

export default modul.name;
